function padLeft(str, length) {
  if (str.length >= length) return str;
  else return padLeft("0" + str, length);
}

export default padLeft;
